import React, { useState } from 'react';
import { createUser } from '../../services/userService';
import { useAuth } from '../../context/AuthContext';

const CreateSystemAdminTest = () => {
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const { userData } = useAuth();

  const createTestSystemAdmin = async () => {
    if (!userData || userData.role !== 'SuperAdmin') {
      setResult({ success: false, error: 'Only Super Admin can create System Admins' });
      return;
    }

    setLoading(true);
    try {
      const newSystemAdmin = {
        name: 'Test System Admin',
        email: 'systemadmin@example.com',
        password: 'SystemAdmin123!',
        role: 'SystemAdmin',
        phone: '+91 9876543210',
        designation: 'System Administrator',
        department: 'IT Operations',
        employeeId: 'SYS001',
        isActive: true,
        createdBy: userData.uid
      };

      const result = await createUser(newSystemAdmin);
      setResult(result);
    } catch (error) {
      setResult({ success: false, error: error.message });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-6 bg-white rounded-lg shadow-sm border border-gray-200 max-w-md">
      <h3 className="text-lg font-semibold text-gray-800 mb-4">Create Test System Admin</h3>
      
      <div className="space-y-3">
        <div className="text-sm text-gray-600">
          <p><strong>Email:</strong> systemadmin@example.com</p>
          <p><strong>Password:</strong> SystemAdmin123!</p>
          <p><strong>Role:</strong> SystemAdmin</p>
        </div>

        <button
          onClick={createTestSystemAdmin}
          disabled={loading || !userData || userData.role !== 'SuperAdmin'}
          className="w-full px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
        >
          {loading ? 'Creating...' : 'Create Test System Admin'}
        </button>

        {result && (
          <div className={`p-3 rounded-lg ${result.success ? 'bg-green-50 border border-green-200' : 'bg-red-50 border border-red-200'}`}>
            <p className={`text-sm ${result.success ? 'text-green-700' : 'text-red-700'}`}>
              {result.success ? 'System Admin created successfully!' : `Error: ${result.error}`}
            </p>
          </div>
        )}

        {!userData && (
          <div className="p-3 bg-yellow-50 border border-yellow-200 rounded-lg">
            <p className="text-sm text-yellow-700">Please login as Super Admin to create System Admin</p>
          </div>
        )}

        {userData && userData.role !== 'SuperAdmin' && (
          <div className="p-3 bg-red-50 border border-red-200 rounded-lg">
            <p className="text-sm text-red-700">Only Super Admin can create System Admin accounts</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default CreateSystemAdminTest;
